/* 130R — seletor de veículo da home (Montadora → Modelo → Ano → Motor).
   Motor (19/10/2026, agente veiculo-motor): obrigatório, ou o chassi no lugar; opções por modelo e ano vindas de
   assets/r130-motores.json (window.R130Motor, assets/r130-motor.js). O motor fica em r130_garage.motor e NÃO vai
   na URL (as etiquetas dos produtos não permitem filtrar por motor). Modelo sem anos nas etiquetas (BMW, Mercedes…):
   os anos vêm do catálogo de motores e o ano também não vai na URL. O card escuta o evento r130:garagem.
   Rodada 2 (decisão do Marcus, 19/10/2026): a LISTA vem da base (window.R130Motor.lista(): só carro e ano com motor;
   Hyundai e Kia primeiro). O endereço da coleção sai de R130Motor.urlColecao (etiquetas da loja: modelo sem etiqueta vai
   para a busca; ano sem etiqueta fica fora). Sem o catálogo, a lista das etiquetas (r130-veiculos.json), como antes.
   Lê r130-veiculos.json (gerado por shopify/veiculos_export.py), monta a URL de filtro por tags
   que o tema já entende (/collections/<montadora>/<modelo>+<ano>[+<motor>]) e guarda o carro
   em localStorage['r130_garage'] ({brand, model, year}) para o selo de compatibilidade da página de produto.
   Modelo sem anos cadastrados (ex.: Mercedes C-350): Ano fica "Todos os anos" e a URL leva só o modelo.
   O botão nunca fica desabilitado: sem montadora/modelo/ano, foca o campo que falta e explica abaixo.
   Funções puras em window.r130Seletor (testadas em tests/test_r130_seletor.js). */
(function () {
  'use strict';

  function slug(s) {
    return String(s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function montarUrl(montadora, modeloTag, ano, motor, base) {
    var tags = [modeloTag];
    if (ano) tags.push(slug(ano));
    if (motor) tags.push(slug(motor));
    return (base || '/collections') + '/' + montadora + '/' + tags.join('+');
  }
  /* "SANTA FÉ" → "Santa Fé"; siglas com número ficam como no dado ("HB20", "C-350"), exceto as
     da linha i da Hyundai ("IX35" → "ix35", "I30" → "i30"); siglas de 1–2 consoantes ficam ("SD"). */
  function nomeBonito(nome) {
    return String(nome).split(' ').map(function (p) {
      if (/\d/.test(p)) return /^I[X]?\d/.test(p) ? p.toLowerCase() : p;
      if (/^[B-DF-HJ-NP-TV-Z]{1,2}$/.test(p)) return p;
      return p.split('-').map(function (q) { return q.charAt(0).toUpperCase() + q.slice(1).toLowerCase(); }).join('-');
    }).join(' ');
  }
  window.r130Seletor = { slug: slug, montarUrl: montarUrl, nomeBonito: nomeBonito };

  var form = document.querySelector('[data-r130-seletor]');
  if (!form) return;
  var sel = {
    montadora: form.querySelector('[name="montadora"]'),
    modelo: form.querySelector('[name="modelo"]'),
    ano: form.querySelector('[name="ano"]'),
    motor: form.querySelector('[name="motor"]')
  };
  var ajuda = form.querySelector('[data-r130-ajuda]');
  var motorCampo = null, anosCatalogo = false;
  // Campo Motor (assets/r130-motor.js, defer, carregado depois deste): criado quando a API estiver pronta.
  function quandoMotor() {
    if (motorCampo) return Promise.resolve(motorCampo);
    if (!sel.motor) return Promise.resolve(null);
    if (window.R130Motor) { motorCampo = window.R130Motor.campo(sel.motor, { chassi: form.querySelector('[data-r130-chassi-campo]') }); return Promise.resolve(motorCampo); }
    return new Promise(function (ok) {
      var t = setTimeout(function () { ok(null); }, 4000);
      document.addEventListener('r130:motor-pronto', function () { clearTimeout(t); ok(quandoMotor()); }, { once: true });
    });
  }
  function atualizarMotor(salvo) {
    return quandoMotor().then(function (mc) {
      if (!mc) return;
      var m = montadora(), md = modelo();
      if (!m || !md) { mc.limpar('Escolha o ano'); return; }
      if (!sel.ano.value) {
        // Modelo sem ano nenhum (nem nas etiquetas nem no catálogo): sem motor para escolher, vale o chassi.
        if (semAnos(md) && !anosCatalogo) return mc.preencher(m.nome, md.nome, null, salvo);
        mc.limpar('Escolha o ano');
        return;
      }
      return mc.preencher(m.nome, md.nome, Number(sel.ano.value), salvo);
    });
  }
  var savedText = form.querySelector('[data-r130-saved-text]');
  var dados = null;

  function opt(value, label) { var o = document.createElement('option'); o.value = value; o.textContent = label; return o; }
  function fill(select, placeholder, items, map) {
    select.innerHTML = '';
    select.appendChild(opt('', placeholder));
    items.forEach(function (it) { var m = map(it); select.appendChild(opt(m[0], m[1])); });
    select.disabled = items.length === 0;
  }
  function montadora() { return dados && dados.montadoras.filter(function (m) { return m.handle === sel.montadora.value; })[0]; }
  function modelo() { var m = montadora(); return m && m.modelos.filter(function (x) { return x.tag === sel.modelo.value; })[0]; }
  function semAnos(md) { return !!md && (!md.anos || md.anos.length === 0); }
  function pronto() { var md = modelo(); return !!(montadora() && md && (sel.ano.value || (semAnos(md) && !anosCatalogo))); }

  function avisar(texto) {
    if (!ajuda) return;
    ajuda.textContent = texto || '';
    ajuda.hidden = !texto;
  }
  function ler() {
    try { return JSON.parse(localStorage.getItem('r130_garage')); } catch (e) { return null; }
  }
  function gravar(car) { try { localStorage.setItem('r130_garage', JSON.stringify(car)); } catch (e) {} }

  function onMontadora() {
    var m = montadora();
    fill(sel.modelo, 'Modelo', m ? m.modelos : [], function (x) { return [x.tag, nomeBonito(x.nome)]; });
    fill(sel.ano, 'Ano', [], function (x) { return [x, x]; });
    sel.ano.required = true;
    anosCatalogo = false;
    atualizarMotor('');
    avisar('');
  }
  function onModelo() {
    var md = modelo();
    anosCatalogo = false;
    if (semAnos(md)) {
      fill(sel.ano, 'Todos os anos', [], function (x) { return [x, x]; });
      sel.ano.required = false;
      // Sem anos nas etiquetas: os anos do catálogo de motores (o carro completo pede o ano; a URL fica sem ele).
      var m = montadora();
      if (window.R130Motor && m) {
        window.R130Motor.anos(m.nome, md.nome).then(function (anos) {
          if (modelo() !== md || !anos.length) return;
          fill(sel.ano, 'Ano', anos.slice().reverse(), function (x) { return [x, x]; });
          sel.ano.required = true;
          anosCatalogo = true;
          var c = ler();
          if (c && c.year && String(c.model).toUpperCase() === md.nome.toUpperCase() && anos.indexOf(Number(c.year)) !== -1) {
            sel.ano.value = String(c.year);
            atualizarMotor(c.motor || '');
          } else atualizarMotor('');
        });
      }
    } else {
      fill(sel.ano, 'Ano', md ? md.anos.slice().sort(function (a, b) { return b - a; }) : [], function (x) { return [x, x]; });
      sel.ano.required = true;
    }
    atualizarMotor('');
    avisar('');
  }
  function limpar() {
    try { localStorage.removeItem('r130_garage'); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('r130:garagem', { detail: null })); } catch (e) {}
    form.classList.remove('is-saved');
    if (dados) { sel.montadora.value = ''; onMontadora(); }
    sel.montadora.focus();
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!dados) { avisar('Carregando a lista de carros, tente de novo em instantes.'); return; }
    if (!pronto()) {
      var falta = !montadora() ? ['montadora', 'Escolha a montadora para continuar.']
        : !modelo() ? ['modelo', 'Escolha o modelo para continuar.']
        : ['ano', 'Escolha o ano para continuar.'];
      avisar(falta[1]);
      sel[falta[0]].focus();
      return;
    }
    var msgMotor = motorCampo ? motorCampo.validar() : '';
    if (msgMotor) {
      e.stopPropagation();   // a medição (r130-medicao.js, no document) não conta um filtro que não aconteceu
      motorCampo.mostrarErro(msgMotor, true);   // a mensagem fica embaixo do botão, como a dos outros campos
      avisar(msgMotor);
      sel.motor.focus();
      return;
    }
    var m = montadora(), md = modelo();
    var motor = motorCampo ? motorCampo.motorParaSalvar() : '';
    var base = (window.theme && window.theme.routes && window.theme.routes.collectionsUrl) || '/collections';
    var carro = { brand: m.nome.toUpperCase(), model: md.nome.toUpperCase(), year: sel.ano.value ? Number(sel.ano.value) : null, motor: motor };
    if (dados.base && window.R130Motor && window.R130Motor.urlColecao) {
      gravar(carro);
      if (window.dataLayer) window.dataLayer.push({ event: 'r130_seletor_veiculo', montadora: m.nome, modelo: md.nome, ano: sel.ano.value || 'todos', motor: motor });
      window.R130Motor.urlColecao(m.nome, md.nome, sel.ano.value).then(function (url) { window.location.href = url; });
      return;
    }
    gravar(carro);   // sem o evento r130:garagem: a página troca já; a medição conta o carro_salvo na página seguinte
    if (window.dataLayer) window.dataLayer.push({ event: 'r130_seletor_veiculo', montadora: m.nome, modelo: md.nome, ano: sel.ano.value || 'todos', motor: motor });
    // O motor não vai na URL; o ano só vai se for uma etiqueta da loja (modelo com anos no r130-veiculos.json).
    window.location.href = montarUrl(m.handle, md.tag, anosCatalogo ? '' : sel.ano.value, '', base);
  });
  sel.montadora.addEventListener('change', onMontadora);
  sel.modelo.addEventListener('change', onModelo);
  sel.ano.addEventListener('change', function () { avisar(''); atualizarMotor(sel.motor ? sel.motor.value : ''); });
  if (sel.motor) sel.motor.addEventListener('change', function () { avisar(''); });
  var btnLimpar = form.querySelector('[data-r130-limpar]');
  if (btnLimpar) btnLimpar.addEventListener('click', limpar);

  function preSelecionar() {
    var car = ler();
    if (!car || !car.brand || !car.model) return;
    var m = dados.montadoras.filter(function (x) { return chv(x.nome) === chv(car.brand); })[0];
    if (!m) return;
    sel.montadora.value = m.handle; onMontadora();
    var md = m.modelos.filter(function (x) { return chv(x.nome) === chv(car.model); })[0];
    if (!md) return;
    sel.modelo.value = md.tag; onModelo();
    if (car.year && md.anos.indexOf(Number(car.year)) !== -1) sel.ano.value = String(car.year);
    if (savedText) savedText.textContent = m.nome + ' ' + nomeBonito(md.nome) + (car.year ? ' ' + car.year : '') + (car.motor ? ' ' + car.motor : '');
    form.classList.add('is-saved');
    if (sel.ano.value) atualizarMotor(car.motor || '');
  }
  // Carro trocado no "Meu carro" (ou em outra aba): o card acompanha.
  function aoTrocarCarro() {
    if (!dados) return;
    if (ler()) preSelecionar();
    else { form.classList.remove('is-saved'); sel.montadora.value = ''; onMontadora(); }
  }
  document.addEventListener('r130:garagem', aoTrocarCarro);
  window.addEventListener('storage', function (ev) { if (ev.key === 'r130_garage') aoTrocarCarro(); });

  // Chave de comparação ("SANTA FÉ" = "Santa Fe"; "Mercedes" = "Mercedes-Benz").
  function chv(s) {
    var k = String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    return { MERCEDES: 'MERCEDESBENZ', VW: 'VOLKSWAGEN' }[k] || k;
  }
  function quandoApi() {
    if (window.R130Motor) return Promise.resolve(window.R130Motor);
    return new Promise(function (ok) {
      var t = setTimeout(function () { ok(window.R130Motor || null); }, 4000);
      document.addEventListener('r130:motor-pronto', function () { clearTimeout(t); ok(window.R130Motor); }, { once: true });
    });
  }
  // Lista da base no formato que o card já usa: handle = chave da montadora, tag = chave do modelo, anos com motor.
  function daBase(lista) {
    return { base: true, montadoras: lista.map(function (m) {
      return { handle: m.key, nome: m.nome, modelos: m.modelos.map(function (md) { return { tag: md.key, nome: md.nome, anos: md.anos.slice() }; }) };
    }) };
  }
  function etiquetas() {
    return fetch(form.getAttribute('data-veiculos'), { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }
  quandoApi()
    .then(function (api) { return api && api.lista ? api.lista() : []; })
    .then(function (lista) { return lista.length ? daBase(lista) : etiquetas(); })
    .then(function (json) {
      dados = json;
      fill(sel.montadora, 'Montadora', dados.montadoras, function (m) { return [m.handle, m.nome]; });
      form.classList.add('is-ready');
      preSelecionar();
    })
    .catch(function () { form.classList.add('is-fallback'); });
})();
